import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./EquipmentSection.css";
import * as Icons from "../Icons";

const allEquipments = [
  {
    category: "Küche und Esszimmer",
    items: [
      { id: 501, name: "Kühlschrank mit Gefrierfach", icon: <Icons.Fridge /> },
      { id: 502, name: "Esstisch", icon: <Icons.Table /> },
      { id: 503, name: "Gaskochfeld", icon: <Icons.GasHob /> },
      { id: 504, name: "Küchenutensilien", icon: <Icons.Pan /> },
      { id: 505, name: "Toaster", icon: <Icons.Toaster /> },
      { id: 506, name: "Wasserkocher", icon: <Icons.Kettle /> },
      {
        id: 507,
        name: "Kaffeemaschine (Tchibo Qbo)",
        icon: <Icons.QboMachine />,
      },
      { id: 508, name: "Mixer", icon: <Icons.Blender /> },
      { id: 509, name: "Weingläser", icon: <Icons.WineGlass /> },
      { id: 510, name: "Geschirrspülmaschine", icon: <Icons.Dishwasher /> },
    ],
  },

  {
    category: "Wohnzimmer",
    items: [
      { id: 101, name: "Schlafsofa", icon: <Icons.Sofa /> },
      { id: 102, name: "Smart-TV", icon: <Icons.TV /> },
    ],
  },
  {
    category: "Badezimmer",
    items: [
      { id: 103, name: "WC", icon: <Icons.WC /> },
      { id: 104, name: "Bidet", icon: <Icons.WC /> },
      { id: 105, name: "Dusche", icon: <Icons.RainShower /> },
      { id: 106, name: "Handtücher", icon: <Icons.Essentials /> },
      { id: 107, name: "Föhn", icon: <Icons.Hairdryer /> },
      { id: 108, name: "Shampoo", icon: <Icons.Shampoo /> },
      { id: 109, name: "Duschgel", icon: <Icons.Shampoo /> },
      { id: 110, name: "Seife", icon: <Icons.Soap /> },
      { id: 111, name: "Toilettenpapier", icon: <Icons.ToiletPaper /> },
      { id: 112, name: "Waschmaschine", icon: <Icons.WashingMachine /> },
      { id: 113, name: "Wäscheständer", icon: <Icons.DryingRack /> },
    ],
  },
  {
    category: "Schlafzimmer",
    items: [
      { id: 201, name: "Grundausstattung", icon: <Icons.Essentials /> },
      { id: 202, name: "Bettwäsche (Baumwolle)", icon: <Icons.BedLinen /> },
      { id: 203, name: "Bügelbrett & Bügeleisen", icon: <Icons.Iron /> },
      { id: 204, name: "Kleiderschrank & Kommode", icon: <Icons.Wardrobe /> },
      { id: 205, name: "Kleiderbügel", icon: <Icons.Hanger /> },
    ],
  },
  {
    category: "Für Familien",
    items: [
      { id: 301, name: "Babybett", icon: <Icons.BabyCrib /> },
      { id: 302, name: "Hochstuhl fürs Baby", icon: <Icons.HighChair /> },
      { id: 303, name: "Brettspiele", icon: <Icons.BoardGame /> },
      { id: 304, name: "Kindergeschirr", icon: <Icons.Cutlery /> },
    ],
  },

  {
    category: "Außenbereiche",
    items: [{ id: 601, name: "Gartenmöbel", icon: <Icons.GardenFurniture /> }],
  },

  {
    category: "Strand",
    items: [
      { id: 701, name: "Sonnenliegen", icon: <Icons.SunLounger /> },
      { id: 702, name: "Sonnenschirm", icon: <Icons.Umbrella /> },
      { id: 703, name: "Campingstühle", icon: <Icons.CampingChair /> },
      {
        id: 703,
        name: "Paddle Board - bis 120kg",
        icon: <Icons.PaddleBoard />,
      },
    ],
  },
  {
    category: "Sicheres Zuhause",
    items: [
      { id: 401, name: "Feuerlöscher", icon: <Icons.Extinguisher /> },
      { id: 402, name: "Erste-Hilfe-Set", icon: <Icons.FirstAid /> },
      { id: 403, name: "Gasmelder", icon: <Icons.GasDetector /> },
    ],
  },
];

function AllEquipmentModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      className="equipment-modal"
    >
      <Modal.Header closeButton className="border-0 px-4 pt-4"></Modal.Header>
      <Modal.Body className="px-4 px-md-5 pb-5">
        <h2 className="modal-main-title mb-5">
          Das bietet dir diese Unterkunft
        </h2>

        {allEquipments.map((section, idx) => (
          <div key={idx} className="mb-4">
            <h3 className="category-title">{section.category}</h3>
            <div className="equipment-list">
              {section.items.map((item) => (
                <div key={item.id} className="equipment-list-item">
                  <div className="equipment-item-icon">
                    {item.icon || <Icons.Essentials />} {/* Fallback Icon */}
                  </div>
                  <div className="equipment-item-name">{item.name}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
}

const EquipmentSection: React.FC = () => {
  const [modalShow, setModalShow] = useState(false);

  // Diese 10 Items werden auf der Hauptseite als Vorschau angezeigt
  const previewEquipments = [
    { id: 1, icon: <Icons.House />, description: "Gesamte Unterkunft" },
    { id: 2, icon: <Icons.M2 />, description: "3 Zimmer, 2 Bäder" },
    { id: 3, icon: <Icons.Cutlery />, description: "Küche" },
    { id: 4, icon: <Icons.Aircondition />, description: "Klimaanlage" },
    { id: 5, icon: <Icons.Nature />, description: "Blick ins Grüne" },
    { id: 6, icon: <Icons.Sea />, description: "Meeresblick" },
    { id: 7, icon: <Icons.Parking />, description: "Privater Parkplatz" },
    { id: 8, icon: <Icons.Veranda />, description: "Veranda" },
    { id: 9, icon: <Icons.Balcony />, description: "Balkon" },
    { id: 10, icon: <Icons.Wifi />, description: "WLAN" },
  ];

  return (
    <section className="section bg-light py-5">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-md-7">
            <h2 className="heading" data-aos="fade-up">
              Ausstattung
            </h2>
            <p data-aos="fade-up" data-aos-delay="100">
              Das beinhaltet unsere Unterkunft
            </p>
          </div>
        </div>

        <div className="row g-3">
          {previewEquipments.map((item) => (
            <div key={item.id} className="col-12 col-sm-6 mb-2">
              <div className="d-flex align-items-center">
                <div className="eq-icon me-3">{item.icon}</div>
                <div className="eq-description">{item.description}</div>
              </div>
            </div>
          ))}

          <div className="col-12 all-equipment-btn mt-4">
            <Button
              variant="outline-dark"
              className="btn btn-primary text-white py-2 mr-3"
              onClick={() => setModalShow(true)}
            >
              Alle{" "}
              {allEquipments.reduce((acc, curr) => acc + curr.items.length, 0)}{" "}
              Ausstattungsmerkmale anzeigen
            </Button>
          </div>
        </div>

        <AllEquipmentModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </div>
    </section>
  );
};

export default EquipmentSection;
